function setCookie(cname, cvalue, exdays) {
  const expires = 'expires='+ exdays;
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const cookies = decodeURIComponent(document.cookie).split(';');

  for (const cookie of cookies) {
    const _cookie = cookie.trim();
    if (_cookie.startsWith(name)) {
      return _cookie.slice(name.length);
    }
  }
  return '';
}

function checkCookie(cname) {
  const name = cname + '=';
  const cookies = decodeURIComponent(document.cookie).split(';');

  for (const cookie of cookies) {
    const _cookie = cookie.trim();
    if (_cookie.startsWith(name)) {
      return true;
    }
  }
  return false;
}

function removeCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

export {
  setCookie,
  getCookie,
  checkCookie,
  removeCookie,
};
